module.exports = __webpack_public_path__ + "img/cart.c7012f0a.png";